import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const PaginationTableStyle = {
  boxPagination: () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
  `,
  paginationStyle: css`
    .ant-pagination-next button {
      color: ${theme.colors.orange[200]} !important;
      &:hover {
        border-color: ${theme.colors.orange[200]} !important;
        background-color: ${theme.colors.white} !important;
      }
    }
    .ant-pagination-prev button {
      color: ${theme.colors.orange[200]} !important;
      &:hover {
        border-color: ${theme.colors.orange[200]} !important;
        background-color: ${theme.colors.white} !important;
      }
    }
    .ant-pagination-disabled button:disabled {
      color: ${theme.colors.gray[10]} !important;
      &:hover {
        border-color: transparent !important;
        background-color: transparent !important;
      }
    }
    .ant-pagination-item-active {
      border-color: ${theme.colors.orange[200]} !important;
    }
    .ant-pagination-item:hover {
      border-color: ${theme.colors.orange[200]} !important;
      background-color: ${theme.colors.white} !important;
    }
    .ant-pagination-item:hover a {
      color: ${theme.colors.orange[200]} !important;
    }
    .ant-pagination-item-active a {
      color: ${theme.colors.orange[200]} !important;
    }
  `,
};
